import React from "react";
import "./OppTeamsModal.css";

const OppTeamsList = ({
  data,
  setSelectedOppTeam,
  visible,
  onBackdropPress,
  error,
}) => {
  const handleSelect = (val) => {
    setSelectedOppTeam(val);
    onBackdropPress();
  };

  return (
    <div className={`overlay ${visible ? "visible" : ""}`}>
      <div className="modal-view">
        <h2 className="select-opp-txt">Select Opponent:</h2>

        {error ? (
          <p className="not-found-txt">Connect to internet and try again!</p>
        ) : data?.length === 0 ? (
          <p className="not-found-txt">No teams found :(</p>
        ) : (
          <div>
            {data ? (
              data.map((val, ind) => (
                <button
                  key={ind}
                  onClick={() => handleSelect(val)}
                  className="opp-team-btn"
                >
                  <span className="option">{val.teamName}</span>
                </button>
              ))
            ) : (
              <div className="spinner"></div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OppTeamsList;
